import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { togglePlannedLucket } from '../../sessionWatchSlice';
import { filteredBucketList } from '../../../../../buckets/slice/lucket-model/filterBuckets';
import { STEP_OPTION, TIMEFRAME } from '../../../../../buckets/constants';
import './LucketSelector.css';

export const LucketSelector = () => {
    const dispatch = useDispatch();
    const buckets = useSelector((state) => state.bucketList.buckets);
    const currentDate = useSelector((state) => state.bucketList.currentDate);
    const plannedLuckets = useSelector((state) => state.timeCounter.plannedLuckets);

    // Get active luckets for today (Do step, Day timeframe)
    const activeBuckets = (buckets && currentDate)
        ? filteredBucketList(buckets, STEP_OPTION.Do, TIMEFRAME.Day, currentDate).filter(l => l && l.rowID)
        : [];

    const handleToggleLucket = (lucketRowId) => {
        dispatch(togglePlannedLucket(lucketRowId));
    };

    return (
        <div className="lucket-selector">
            <h3>Select Luckets to Work On:</h3>
            <div className="lucket-list">
                {activeBuckets.filter(lucket => lucket && lucket.rowID).map((lucket) => (
                    <div
                        key={lucket.rowID}
                        className={`lucket-item ${plannedLuckets.includes(lucket.rowID) ? 'selected' : ''}`}
                        onClick={() => handleToggleLucket(lucket.rowID)}
                    >
                        <input
                            type="checkbox"
                            checked={plannedLuckets.includes(lucket.rowID)}
                            readOnly
                        />
                        <span className="lucket-name">{lucket.name}</span>
                        <span className="lucket-category">Category {lucket.category}</span>
                    </div>
                ))}
            </div>
            {activeBuckets.length === 0 && (
                <p className="no-luckets">No active luckets for today</p>
            )}
        </div>
    );
};
